import Vue from 'vue'
import Router from 'vue-router'

// store
// import store from '@/store'

// 自定义
import { storageName, systemTitle } from '@/assets/js/const'
import { setDocumentTitle, removeElement } from '@/assets/js/util'

// 最主要的Layout
import { IndexLayout, UserLayout } from '@/layouts'

// 顶部加载条
import NProgress from 'nprogress' // progress bar
import '@/components/NProgress/nprogress.less' // progress bar custom style
NProgress.configure({ showSpinner: false }) // NProgress Configuration

// 提示
import { Notification } from 'ant-design-vue';

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
      {
          path: '/',
          name: 'default',
          meta: { title: '' },
          component: IndexLayout,
          children: [{
              path: '/',
              name: 'index',
              meta: { title: '' },
              component: () => import('@/views/Index'),
          }]
      }
  ]
})

router.beforeEach((to, from, next) => {
    NProgress.start() // loading

    let meta = to.meta || {};
    setDocumentTitle(`${meta.title ? `${meta.title} - ` : ''}${systemTitle}`)

    // 跳到登陆页面
    // if(to.path == '/login') {
    //     if(authData) {
    //         next('/')
    //         return
    //     }
        
    //     NProgress.done()
    //     next()
    //     return
    // }

    // if(!authData) {
    //     next('/login')
    //     return;
    // }

    next()
})

router.afterEach(() => {

    NProgress.done() // finish progress bar
    removeElement('loading-mask')
})


export default router
